import { BaseService } from '@zaoblako/web/core/services/base.service';

import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { FilialItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-items-page.dto';
import type { FilialFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find-many-query.dto';
import type { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';

import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilialService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/filial';

  public get dropdownDescriptorUrl(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: FilialFindManyQueryInterface): Observable<FilialItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<FilialItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public history(queryParams: PaginationRequiredQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public synchronizeAll(): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/synchronize`);
  }

  public restore(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
